import * as React from "react";
const IconSyringe = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M61.6 15.3 48.7 2.4c-.9-.9-2.3-.9-3.2 0s-.9 2.3 0 3.2l4.8 4.8-4.9 4.9-1-1c-3-3-7.9-3-10.9 0L15.6 32.4c-1.8 1.8-2.5 4.3-2.1 6.7L11 41.5C9.6 43 8.8 44.9 8.8 47c0 1.4.4 2.8 1.1 4l-7.5 7.5c-.9.9-.9 2.3 0 3.2.4.4 1 .7 1.6.7s1.2-.2 1.6-.7l7.5-7.5c1.2.7 2.5 1.1 4 1.1 2.1 0 4-.8 5.5-2.3l2.4-2.4c.4.1.8.1 1.3.1 2 0 3.9-.8 5.5-2.3l18.1-18.1c3-3 3-7.9 0-10.9l-1-1 4.9-4.9 4.8 4.8c.4.4 1 .7 1.6.7s1.2-.2 1.6-.7c.7-.7.7-2.2-.2-3M14.8 49.8l-.5-.5c-.6-.6-.9-1.4-.9-2.3s.3-1.7.9-2.3l1.4-1.4 5.1 5.1-1.4 1.4c-1.3 1.2-3.4 1.2-4.6 0m31.7-22.6-18.1 18c-1.3 1.2-3.3 1.3-4.5 0l-5.1-5.1c-1.3-1.3-1.3-3.3 0-4.5l18.1-18.1c1.3-1.3 3.3-1.3 4.5 0l5.1 5.1c1.3 1.3 1.3 3.3 0 4.6" />
  </svg>
);
export default IconSyringe;
